import React from 'react';
import { createRoot } from 'react-dom/client';
import SystemStatsLink from './SystemStatsLink';
import type { SystemStatsHandle, SystemStatsProps } from './types';

declare global {
  interface Window {
    mountSystemStats: (containerId: string, props: SystemStatsProps) => SystemStatsHandle;
  }
}

window.mountSystemStats = function mountSystemStats(
  containerId: string,
  props: SystemStatsProps,
): SystemStatsHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('SystemStats: container not found:', containerId);
    return { type: 'system-stats', unmount: () => {} };
  }

  const root = createRoot(container);
  root.render(React.createElement(SystemStatsLink, props));

  return {
    type: 'system-stats',
    unmount: () => root.unmount(),
  };
};

export type {
  DiskSnapshot,
  NetworkSnapshot,
  SystemSnapshot,
  SystemStatsResponse,
  Sample,
  ChartSeries,
  TabId,
  SystemStatsProps,
  SystemStatsHandle,
} from './types';
